/* global System */

export default {
  SelectWithInput: () =>
    System.import(/* webpackChunkName: "SelectWithInput" */ './index'),
}
